import type { TileMapRenderer } from '../renderer/tilemap/TileMapRenderer';

const SIZE_STEP = 0.05;
const MIN_SIZE_MULTIPLIER = 0.1;
export const MAP_OBJECT_PLACEMENT_SCALE_CHANGED_EVENT = 'map-object-placement-scale-changed';

let currentSizeMultiplier = 1;

function isEditableTarget(target: EventTarget | null): boolean {
  return target instanceof HTMLInputElement
    || target instanceof HTMLTextAreaElement
    || target instanceof HTMLSelectElement
    || (target instanceof HTMLElement && target.isContentEditable);
}

export function getVisualAssetSizeMultiplier(): number {
  return currentSizeMultiplier;
}

function logSizeMultiplier(): void {
  console.log('[VisualAssetSizeMultiplier]', currentSizeMultiplier);
}

function dispatchSizeMultiplierChanged(): void {
  window.dispatchEvent(new CustomEvent(MAP_OBJECT_PLACEMENT_SCALE_CHANGED_EVENT, {
    detail: { sizeMultiplier: currentSizeMultiplier },
  }));
}

export function createVisualAssetPlacementOffsetHotkeys(renderer: Pick<TileMapRenderer, 'requestRender'>): { dispose(): void } {
  const handleWheel = (event: WheelEvent): void => {
    if (!event.shiftKey || isEditableTarget(event.target)) {
      return;
    }

    const direction = event.deltaY < 0 ? 1 : -1;
    currentSizeMultiplier = Math.max(
      MIN_SIZE_MULTIPLIER,
      Number((currentSizeMultiplier + direction * SIZE_STEP).toFixed(2)),
    );
    logSizeMultiplier();
    dispatchSizeMultiplierChanged();
    renderer.requestRender();
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  };

  window.addEventListener('wheel', handleWheel, { capture: true, passive: false });

  return {
    dispose(): void {
      window.removeEventListener('wheel', handleWheel, true);
    },
  };
}
